import React, { useContext, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  FormControl,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import PhoneField from "./PhoneField";
import ConfigContext from "../context/ConfigContext";
import EmailInput from "./EmailInput";
import bkstApi from "../api";
import LinearProgress from "@mui/material/LinearProgress";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import StaticPage from "../screen/StaticPage";

export default function Contact(props) {
  const siteConfig = useContext(ConfigContext);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [consent, setConsent] = useState(false);

  const [status, setStatus] = useState("");
  const [errors, setErrors] = useState([]);

  const validate = () => {
    let arr = [];
    if (!phone) {
      arr.push("Phone is missing");
    } else if (phone.length < 10) {
      arr.push("Invalid Phone Number");
    }

    if (email.length < 5 || !email.includes("@") || !email.includes(".")) {
      arr.push("Invalid Email");
    }

    if (!message) {
      arr.push("Message is missing");
    }

    return arr;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const arr = validate();
    if (arr.length > 0) {
      setErrors(arr);
    } else {
      setStatus("processing");

      bkstApi
        .post(`/site/${siteConfig.id}/inquiry`, {
          customer: { firstName, lastName, email, phone },
          title: props.title,
          message,
        })
        .then((res) => {
          setStatus("success");
        });
    }
  };

  if (!status) {
    return (
      <Box>
        <form onSubmit={onSubmit}>
          <Paper elevation={0}>
            <Box p={4}>
              <Grid container spacing={3} align="left">
                <Grid item xs={12}>
                  <FormControl variant="outlined" fullWidth>
                    <TextField
                      value={message}
                      variant="outlined"
                      fullWidth
                      id="message"
                      name="message"
                      label="Message"
                      multiline
                      rows={4}
                      onChange={(e) => setMessage(e.target.value)}
                      placeholder="Include details like event date, number of guests, age group, dietary preferences, etc"
                    />
                  </FormControl>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <FormControl variant="outlined" fullWidth>
                    <TextField
                      value={firstName}
                      variant="outlined"
                      fullWidth
                      id="firstName"
                      label="First Name"
                      name="firstName"
                      onChange={(e) => setFirstName(e.target.value)}
                      required
                    />
                    <FormHelperText></FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <FormControl variant="outlined" fullWidth>
                    <TextField
                      value={lastName}
                      variant="outlined"
                      fullWidth
                      id="lastName"
                      label="Last Name"
                      name="lastName"
                      onChange={(e) => setLastName(e.target.value)}
                      required
                    />
                    <FormHelperText></FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <EmailInput value={email} onChange={(val) => setEmail(val)} required={true} />
                </Grid>

                <Grid item xs={12}>
                  <FormControl variant="outlined" fullWidth>
                    <PhoneField
                      name="Mobile"
                      value={phone}
                      onChange={(phone) => setPhone(phone)}
                      required
                    />
                  </FormControl>
                  <Box mt={1}>
                    <FormControlLabel
                      required
                      className="consent"
                      control={
                        <Checkbox
                          required
                          checked={consent}
                          onChange={(e) => setConsent(e.target.checked)}
                          name="consent"
                          color="secondary"
                        />
                      }
                      label={`I consent to receiving calls and SMS messages from ${siteConfig.biz}`}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
            {errors.length > 0 && (
              <Grid item xs={12}>
                <Alert severity="error">{errors.join(". ")}</Alert>
              </Grid>
            )}
          </Paper>
          <Box my={2}>
            <Button size="large" fullWidth variant="contained" color="primary" type="submit">
              Submit
            </Button>
          </Box>
        </form>
      </Box>
    );
  } else if (status === "processing") {
    return <LinearProgress />;
  } else if (status === "success") {
    return (
      <StaticPage
        title="Message Received"
        desc="Thank you for contacting us. We'll review your message shortly & get back to you soon."
        icon={CheckCircleIcon}
      ></StaticPage>
    );
  }
}
